import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchCurrency, SaveCurrency } from '../actions/currency';
import { Route, Switch, Router } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';

import TripSearch from './tripSearch';
import ProductBasket from './departure/productbasket';
import Sequences from './discover';
import Preview from './preview';
import Builder from './builder';
import Cyoa from './itinerary';
import Details from './itinerary/details';
import EditTrip from './itinerary/editTrip';
import City from './itinerary/city';
import Mapbox from './mapbox';
import WithError from './error/withError';
import GenericError from './error/genericerror';

const rootDataSet = document.getElementById("root").dataset;

export const history = createBrowserHistory({basename:(rootDataSet.basename !== "" )? rootDataSet.basename : ""});


class App extends PureComponent {

  componentDidMount(){


    //Scroll window to top
    window.scrollTo(0, 0);

    //Initialise image lazy loading
    lazysizes.init();

    //Check or Busabout global variable
    // window.Busabout = window.Busabout || {}

    //DISABLED FOR NOW
    /*if(rootDataSet.target === "/" || rootDataSet.target === null){

      //Fetch currency data and default to fallback if the currency API fails
      this.loadCurrencyContent();

      //Save active view
      this.props.SetActiveView((parsed.travelstyle !== 'cyoa') ? 'trip' : 'cyoa');

    }else{

      //Fetch currency data and default to fallback if the currency API fails
      this.props.FetchCurrency();
    }*/


    //Fetch currency data and default to fallback if the currency API fails
    this.props.FetchCurrency();


  }

//DISABLED FOR NOW
/*  loadCurrencyContent(){

    if (typeof (window.Busabout) !== 'undefined') {

      //isoCurrency of parent container
      const isoCurrencyValue = document.documentElement.parentNode.getElementById('isoCurrency').value;

       if(isoCurrencyValue !== ""){
           let currencyMod = Object.assign({}, this.props.currencyInfo);
           let isCurrencyValid = some(COUNTRIES, function(data){return data.country === isoCurrencyValue });

           if(isCurrencyValid){
             currencyMod.iso_currency_code = isoCurrencyValue;
             currencyMod.currency_mask = filter(COUNTRIES, function(num){ return num.country === isoCurrencyValue})[0].currency;
           }else{
             currencyMod.iso_currency_code = "USD";
             currencyMod.currency_mask = "$";
           }

           this.props.SaveCurrency({currencyInfo:currencyMod});
       }

    }

}
*/


  renderTargetedRoute(target){
    return(
      <Router history={history} basename={rootDataSet.basename}>
        <Switch>
          <Route exact path="/" component={TripSearch} />
          <Route path={process.env.REACT_APP_DISCOVER_PAGE} component={Sequences} />
          <Route path={process.env.REACT_APP_DISCOVER_EUROPE_PAGE} component={Sequences} />
          <Route path={process.env.REACT_APP_DISCOVER_USA_PAGE} component={Sequences} />
          <Route path={process.env.REACT_APP_PREVIEW_PAGE} component={Preview} />
          <Route path={process.env.REACT_APP_BUILDER_PAGE} component={Builder} />
          <Route path={process.env.REACT_APP_DEPARTURE_PAGE} component={ProductBasket} />
          <Route exact path={process.env.REACT_APP_ITINERARY_PAGE} component={Cyoa} />
          <Route path={process.env.REACT_APP_ITINERARY_DETAILS_PAGE} component={Details} />
          <Route path={process.env.REACT_APP_ITINERARY_EDIT_PAGE} component={EditTrip} />
          <Route path={process.env.REACT_APP_ITINERARY_CITY_PAGE} component={City} />
          <Route path={process.env.REACT_APP_MAPBOX_PAGE} component={Mapbox} />
        </Switch>
      </Router>
    )
  }

  render() {

    //Appmode for matrix and standalone
    if(rootDataSet.appmode === 'false'){
      return (
        <Fragment>
          {(rootDataSet.target === "/" || rootDataSet.target === null) && this.renderTargetedRoute('/') }
          {rootDataSet.target === `${process.env.REACT_APP_DISCOVER_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_DISCOVER_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_DISCOVER_EUROPE_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_DISCOVER_EUROPE_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_DISCOVER_USA_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_DISCOVER_USA_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_PREVIEW_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_PREVIEW_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_BUILDER_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_BUILDER_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_DEPARTURE_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_DEPARTURE_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ITINERARY_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ITINERARY_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ITINERARY_DETAILS_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ITINERARY_DETAILS_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ITINERARY_EDIT_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ITINERARY_EDIT_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_ITINERARY_CITY_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_ITINERARY_CITY_PAGE}`) }
          {rootDataSet.target === `${process.env.REACT_APP_MAPBOX_PAGE}` && this.renderTargetedRoute(`${process.env.REACT_APP_MAPBOX_PAGE}`) }
        </Fragment>
      )
    }
    else{
        return (
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={TripSearch} />
              <Route path={process.env.REACT_APP_DISCOVER_PAGE}  render={ () => <Sequences /> } />
              <Route path={process.env.REACT_APP_DISCOVER_EUROPE_PAGE} component={Sequences} />
              <Route path={process.env.REACT_APP_DISCOVER_USA_PAGE} component={Sequences} />
              <Route path={process.env.REACT_APP_PREVIEW_PAGE} component={Preview} />
              <Route path={process.env.REACT_APP_BUILDER_PAGE} component={Builder} />
              <Route path={process.env.REACT_APP_DEPARTURE_PAGE} component={ProductBasket} />
              <Route exact path={process.env.REACT_APP_ITINERARY_PAGE} component={Cyoa} />
              <Route path={process.env.REACT_APP_ITINERARY_DETAILS_PAGE} component={Details} />
              <Route path={process.env.REACT_APP_ITINERARY_EDIT_PAGE} component={EditTrip} />
              <Route path={process.env.REACT_APP_ITINERARY_CITY_PAGE} component={City} />
              <Route path={process.env.REACT_APP_MAPBOX_PAGE} component={Mapbox} />
              <Route path="/500" component={WithError(GenericError, '500')}/>
              <Route component={WithError(GenericError, '404')} />
            </Switch>
          </Router>
        );
    }

  }
}

function mapStateToProps(state){
  return{
    currency:state.currency,
    currencyInfo:state.currencyInfo
  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchCurrency,
    SaveCurrency
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/app.js